import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import OrderReturnDetailContainer from '../../containers/order/OrderReturnDetailContainer';
import { ORDER_PAGE_NAME } from '../../constants/service/app/orderConstants';

const OrderReturnDetail = () => {
  return (
    <PageTemplate pageName={ORDER_PAGE_NAME.ORDER_RETURN_DETAIL}>
      <OrderReturnDetailContainer />
    </PageTemplate>
  );
};

export default OrderReturnDetail;
